import "scripts/templates/index.js";
import { registerBundle } from "scripts/lib/register-bundle.js";
registerBundle("template.index");
